import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { Warning } from '../../../components/warning'

const UnavailableMfe: FC = (): React.ReactElement => {
  const navigate = useNavigate()

  return (
    <Warning
      icon='tools'
      title='Página temporariamente indisponível'
      description='Parece que a página que você está tentando acessar está temporariamente indisponível. Tente
      novamente mais tarde.'
      label='Voltar ao início'
      ariaLabel='Voltar ao início'
      onResolve={() => navigate('/')}
    />
  )
}

export default UnavailableMfe
